import polyline from '@mapbox/polyline';
export const utils = {
    polyline,
};
//# sourceMappingURL=index.js.map